// @flow
export const CHAPTER_EVENT_TYPES: Array<string> = [
  "chapter-kickoff-event",
  "chapter-community-event",
  "chapter-monthly-meetup",
];

export const isChapterEventType = (type: ?string): boolean =>
  CHAPTER_EVENT_TYPES.includes(type || "");

export const normalizeChapterEventType = (type: ?string): string =>
  isChapterEventType(type) ? type || "" : "";

export const SCHEDULE_CHAPTER_EVENTS_FORM = "scheduleChapterEventsForm";
